import { render } from "./UploadTeamLogoForm.vue?vue&type=template&id=8f87e3ba&scoped=true"
import script from "./UploadTeamLogoForm.vue?vue&type=script&lang=js"
export * from "./UploadTeamLogoForm.vue?vue&type=script&lang=js"

import "./UploadTeamLogoForm.vue?vue&type=style&index=0&id=8f87e3ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f87e3ba"]])

export default __exports__